import { Space } from "antd";
import type { ColumnsType } from "antd/es/table";
import { Link } from "react-router-dom";
import DeleteIcon from "@/assets/icons/DeleteIcon";
import EditIcon from "@/assets/icons/EditIcon";
import NextIcon from "@/assets/icons/NextIcon";
import routes from "@/routes";
import { CompanyType } from "@/utils/types";

export const columns = ({
  onDelete,
  onRestore,
  loadingList,
}: {
  onDelete?: (id: string | number) => void;
  onRestore?: (id: string | number) => void;
  isLoadingExportUserApi?: boolean;
  isLoadingExportWarehouseApi?: boolean;
  loadingList?: Array<string | number>;
}) => {
  return [
    {
      title: "No.",
      dataIndex: "id",
      key: "id",
      render: (text, record, index) => (
        <div
          style={{
            color: record?.deletedAt ? "#5B5959" : "#000000E0",
            maxWidth: 120,
          }}
        >
          {index + 1}
        </div>
      ),
    },
    {
      title: "Role",
      dataIndex: "name",
      key: "name",
      render: (text, record) => (
        <span
          style={{
            color: record?.deletedAt ? "#5B5959" : "#000000E0",
          }}
        >
          {text}
        </span>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status, record) => (
        <span
          style={{
            color: record?.deletedAt ? "#5B5959" : "#000000E0",
          }}
        >
          {status === 1 ? "Active" : "Inactive"}
        </span>
      ),
    },
    {
      title: "Functions",
      key: "action",
      render: (_, record) => {
        const isLoading = !!(loadingList || []).find((item) => item === record?.id);

        return (
          <Space
            size="middle"
            style={{
              maxWidth: 380,
              fontSize: 12,
            }}
          >
            {record?.deletedAt ? (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 6,
                  color: "#192EEB",
                  cursor: "pointer",
                  justifyContent: "center",
                  width: "100%",
                }}
                onClick={() => (isLoading ? undefined : onRestore?.(record?.id))}
              >
                <span>Restore</span>
                <span>&gt;&gt;</span>
              </div>
            ) : (
              <>
                <Link to={routes.viewRole.path.replace(":id", record?.id || "")}>
                  <NextIcon style={{ width: 16, cursor: "pointer" }} />
                </Link>
                <Link to={routes.editRole.path.replace(":id", record?.id || "")}>
                  <EditIcon style={{ width: 16, cursor: "pointer" }} />
                </Link>
                <div onClick={() => (isLoading ? undefined : onDelete?.(record?.id || ""))}>
                  <DeleteIcon style={{ width: 16, cursor: "pointer" }} />
                </div>
              </>
            )}
          </Space>
        );
      },
    },
  ] as ColumnsType<CompanyType>;
};
